
































































import { PartnerPracticeEmailAttachment } from '@/shared/partner-practice-email-attachment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const attachmentModule = namespace('attachment');

@Component
export default class PartnerPracticeEmail extends Vue {
    @attachmentModule.Getter('files') private attachmentFiles!: Array<string>;

    @Prop({ required: true }) private attachment!: PartnerPracticeEmailAttachment;

    private importFile: boolean = false;
    private attachmentFile: File | null = null;

    private get attachmentExtension(): string | null {
        if (!this.importFile && this.attachment.attachmentFilename != null) {
            return `.${this.attachment!.attachmentFilename!.split('.').pop()}`;
        }

        if (this.importFile && this.attachmentFile != null) {
            return `.${this.attachmentFile.name.split('.').pop()}`;
        }

        return null;
    }

    @Watch('importFile')
    private onImportFileChanged(): void {
        this.attachment.attachmentFilename = null;
        this.attachmentFile = null;
        this.$emit('import-file', this.importFile);
    }

    @Watch('attachmentFile')
    private onAttachmentFileChanged(): void {
        this.$emit('file-changed', this.attachmentFile);
    }

    private async mounted(): Promise<void> {
        await this.$store.dispatch(`attachment/fetchEmailAttachmentsAsync`);
    }
}
